import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';
import LoginPage from './loginSignUp/login';
import SignUp from './loginSignUp/registration';
import LandingPage from './general/landingpage';
import ProfilePage from './profile/profile';
import Dashboard from './user/dashboard';
import CreatePost from './event/create';
import ProfileUpdatePage from './profile/profileupdate';
import ActDetail from './program/program';
import ActEdit from './event/actedit';
import DonatePage from './general/donate';
import AccountInfo from './user/info';
import Message from './user/message_temp';
import ProfileViewPage from './profile/profileview';
import Email from './loginSignUp/email';
import TeamView from '../teamview';
import THNKPage from '../thankyou';
import Inbox from './user/inbox';
import About from './general/about';
import Team from './general/team';
import ForgotPassword from './loginSignUp/forgotpassword';
import Datatable from './user/certificate';
import SingleEvent from './event/singleEvent';
import CreatePrograms from './program/createProgram';
import CredsDataTable from './program/credsDataTable';
import EditProgram from './program/editProgram'
import AllProgramsWithoutAuth from './withoutAuth/AllProgramsWithoutAuth';
import ProgramApproval from './program/programApproval'
import TimelinePage from './program/timeline'
import EventTimelinePage from './event/eventsTimeline'
import ContactUs from './general/contact';
import BulkRegister from './loginSignUp/bulkRegister';
import HumanLibrary from './humanLibrary/humanLibrary';
import HumanLibraryRequests from './humanLibrary/humanLibraryRequests'
import ChooseProfile from './profile/chooseProfile';
import BulkProfileCreate from './loginSignUp/bulkProfileCreate'
import Terms from './general/terms'
import PrivacyPolicy from './general/privacyPolicy';
import RefundPolicy from './general/refundPolicy';
import ShippingAndDeliveryPolicy from './general/shippingAndDeliveryPolicy';
import GOTAbout from './giftoftime/about';
import JCAbout from './jobcreds/about';
import EventCalendar from './event/calendar';
import CouponDonationPage from './general/CouponDonationPage';
import PhonePeDonate from './general/phonepeDonate';
import PhonePeThankyou from './general/phonepeThankyou';
import MyPrograms from './program/myPrograms';
import MyEvents from './event/myEvents';
import Blog from './general/blog';

function HomePage() {
  let localUserData = {};
  localUserData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : localUserData;
  localUserData.id = localStorage.getItem("userID") ? parseInt(localStorage.getItem("userID")) : null;
  localUserData.token = localStorage.getItem("token") ? localStorage.getItem("token") : null;

  let isMobile = false;

  if (window.innerWidth < 900) {
    isMobile = (true);
  }

  return (
    <Router>
      <Routes>
        <React.Fragment>

          <Route path='/' element={<LandingPage isMobile={isMobile} localUserData={localUserData} />} />

          {/* <div style={{ marginTop: 80, }}> */}

          {process.env.REACT_APP_HOST_NAME === 'giftoftime' && (
            <React.Fragment>
              <Route path='/about' exact element={<GOTAbout />}></Route>
            </React.Fragment>
          )}

          {process.env.REACT_APP_HOST_NAME === 'socialcreds' && (
            <React.Fragment>
              <Route path='/about' exact element={<About />}></Route>
            </React.Fragment>
          )}

          {process.env.REACT_APP_HOST_NAME === 'jobcreds' && (
            <React.Fragment>
              <Route path='/about' exact element={<JCAbout />}></Route>
            </React.Fragment>
          )}

          {/* GENERAL ROUTES */}
          <Route path='/dashboard' exact element={<Dashboard />} />
          <Route path='/contact-us' exact element={<ContactUs />} />
          <Route path='/login' exact element={<LoginPage />} />
          <Route path='/signup/:type' element={<SignUp />} />
          <Route path='/email' exact element={<Email />} />
          <Route path='/donate' exact element={<PhonePeDonate />} />
          <Route path='/phonepe/donate' exact element={<PhonePeDonate />} />
          <Route path='/razorpay/donate' exact element={<DonatePage />} />
          <Route path='/activate/:uidb64/:token/' element={<Message />} />
          <Route path='/password-reset/:uidb64/:token/' element={<ForgotPassword />} />
          <Route path='/info' exact element={<AccountInfo />}></Route>
          <Route path='/inbox' exact element={<Inbox />}></Route>
          <Route path='/thankyou' component={PhonePeThankyou} />
          <Route path='/razorpay/thankyou' component={THNKPage} />
          <Route path='/tncs' exact element={<Terms />}></Route>
          <Route path='/terms' exact element={<Terms />}></Route>chc
          <Route path='/privacy-policy' exact element={<PrivacyPolicy />}></Route>
          <Route path='/refund-policy' exact element={<RefundPolicy />}></Route>
          <Route path='/shipping-delivery-policy' exact element={<ShippingAndDeliveryPolicy />}></Route>
          <Route path='/coupon/donate' exact element={<CouponDonationPage isMobile={isMobile} />} />
          <Route path='/blogspot' exact element={<Blog />} />
          <Route path='/blogspot/:id' element={<Blog />} />
          <Route path='/blog' exact element={<Blog />} />
          <Route path='/blog/:id' element={<Blog />} />

          {/* HUMAN LIBRARY ROUTES */}
          <Route path='/human-library' element={<HumanLibrary isMobile={isMobile} localUserData={localUserData} />} />
          <Route path='/human-library/requests' element={<HumanLibraryRequests isMobile={isMobile} localUserData={localUserData} />} />

          {/* BULK ROUTES */}
          <Route path='/group/register' exact element={<BulkRegister />} />
          <Route path='/group/profile/register' exact element={<BulkProfileCreate />} />

          {/* EVENT ROUTES */}
          <Route path='/event/edit/:id' element={<ActEdit />} />
          <Route path='/event/:id' element={<SingleEvent />} />
          <Route path='/events/timeline' exact element={<EventTimelinePage />} />
          <Route path='/event/creds/:id' element={<CredsDataTable />} />
          <Route path='/event/create/:id' exact element={<CreatePost />} />
          <Route path='/calendar/event' exact element={<EventCalendar />} />

          {/* PROFILE ROUTES */}
          <Route path='/profile' exact element={<ProfilePage />} />
          <Route path='/profiles/choose' exact element={<ChooseProfile />} />
          <Route path='/profile/:id' element={<ProfileViewPage />} />
          <Route path='/edit/profile' exact element={<ProfileUpdatePage />} />

          {/* TEAM ROUTES */}
          <Route path='/team' exact element={<Team />} />
          <Route path='/team/:name' element={<TeamView />} />
          <Route path='/team/credit/:id' element={<Datatable type={1} />} />
          <Route path='/team/debit/:id' element={<Datatable type={2} />} />

          {/* PROGRAM ROUTES */}
          <Route path='/program/:id' element={<ActDetail />} />
          <Route path='/programs/timeline' exact element={<TimelinePage />} />
          <Route path='/programs/create' element={<CreatePrograms />} />
          <Route path='/program/creds/:id' element={<CredsDataTable type={1} />} />
          <Route path='/edit/program/:id' element={<EditProgram />} />
          <Route path='/programs/all' element={<AllProgramsWithoutAuth />} />
          <Route path='/programs/approvals' element={<ProgramApproval />} />
          <Route path='/myprograms' exact element={<MyPrograms />} />
          <Route path='/myevents' exact element={<MyEvents />} />

          {/* <Route path="/test" exact element={Test}></Route> */}
          {/* </div> */}
        </React.Fragment>
      </Routes>
    </Router>
  );

}

export default HomePage;
